/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Uppbeat.Api | v1
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  HttpValidationProblemDetails,
  PostSearchSuggestionRequestBody
} from '../model';

import { apiClient } from '../../lib/api-client';




export const postApiV1SearchSuggestions = (
    postSearchSuggestionRequestBodyNull: PostSearchSuggestionRequestBody | null,
 signal?: AbortSignal
) => {


      return apiClient<void>(
      {url: `/api/v1/search-suggestions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postSearchSuggestionRequestBodyNull, signal
    },
      );
    }




export const getPostApiV1SearchSuggestionsMutationOptions = <TError = HttpValidationProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1SearchSuggestions>>, TError,{data: PostSearchSuggestionRequestBody | null}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiV1SearchSuggestions>>, TError,{data: PostSearchSuggestionRequestBody | null}, TContext> => {

const mutationKey = ['postApiV1SearchSuggestions'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiV1SearchSuggestions>>, {data: PostSearchSuggestionRequestBody | null}> = (props) => {
          const {data} = props ?? {};

          return  postApiV1SearchSuggestions(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostApiV1SearchSuggestionsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiV1SearchSuggestions>>>
    export type PostApiV1SearchSuggestionsMutationBody = PostSearchSuggestionRequestBody | null
    export type PostApiV1SearchSuggestionsMutationError = HttpValidationProblemDetails | null

    export const usePostApiV1SearchSuggestions = <TError = HttpValidationProblemDetails | null,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiV1SearchSuggestions>>, TError,{data: PostSearchSuggestionRequestBody | null}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postApiV1SearchSuggestions>>,
        TError,
        {data: PostSearchSuggestionRequestBody | null},
        TContext
      > => {
      return useMutation(getPostApiV1SearchSuggestionsMutationOptions(options), queryClient);
    }
